import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { SharedService } from 'src/app/service/shared/shared.service';
import { HttpService } from 'src/app/service/http/http.service';
import { GenericService } from 'src/app/services/genericService/generic.service';
import { GetCompanyAndUsersData } from 'src/app/services/get-company-and-users-data/get-company-and-users-data.service';
import { DwmGenericServiceService, TableState } from '../../_DWM-Generic-Services/generic-service.service';
import * as CommonFunctions from 'src/app/shared/commen-function-file';
import { Config } from 'src/app/app-constant';
import { TimeOnlyPipePipe } from 'src/app/shared/pipe/time-only-pipe.pipe';
import { AllPopupModalExecutionServiceService } from 'src/app/shared/services/all-popup-modal-execution-service.service';
import { DwmattachmentpopupComponent } from '../../My-DWM/dwmattachmentpopup/dwmattachmentpopup.component';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-dwmaudittrailhr',
  templateUrl: './dwmaudittrailhr.component.html',
  styleUrls: ['./dwmaudittrailhr.component.scss']
})
export class DwmaudittrailhrComponent implements OnInit {
  loggedInUserCompanyID: any;
  loggedInUserId: any;
  auditHeaders: string[] = ['Field Name', 'Old Value', 'Created At', 'New Value', 'Modified By', 'Modified Date'];
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public sharedService: SharedService,
    private httpService: HttpService,
    private config: Config,
    public dialog: MatDialog,
    private toastr: ToastrService,
    public genericService: GenericService,
    private datePipe: DatePipe,
    private timeOnlyPipePipe: TimeOnlyPipePipe,
    public dwmGenericServiceService: DwmGenericServiceService,
    public getCompanyAndUsersData: GetCompanyAndUsersData,
    private allPopupModalExecutionServiceService: AllPopupModalExecutionServiceService,
    private loader: LoaderService
  ) {}

  ngOnInit() {
    this.loggedInUserCompanyID = this.getCompanyAndUsersData.loggedInUserCompanyID;
    this.loggedInUserId = this.getCompanyAndUsersData.loggedInUserId;
    this.getAuditTrail();
  }

  selectedYear() {
    return this.getCompanyAndUsersData.convertFinancialYear(this.getCompanyAndUsersData?.loggedInCompanyFiscalyear || '', 'yearTextToNumber', '_');
  }

  auditData: any[] = [];

  getAuditTrail() {
    this.httpService.callGetService(`${this.config.getAuditForHR}?companyId=${this.loggedInUserCompanyID}`).subscribe(
      (res: any) => {
        console.log('response is audit....', res);

        if (res?.data && Array.isArray(res.data.logs)) {
          this.auditData = res.data.logs;
        } else {
          this.auditData = [];
        }
      },
      error => {
        console.error('Audit API Error:', error);
        this.auditData = [];
      }
    );
  }
}
